import { latestActivityTimestampMs } from '../services/activityService';

/**
 * Regelbasiertes Lead-Scoring (0–100), ergänzt manuelles Scoring.
 * Aufruf z. B. nach Speichern von Status/Branche oder per Button „Neu berechnen“.
 */
export function computeLeadScoreFromRules(lead, activities = []) {
  if (!lead) return 0;
  const status = (lead.status || '').toLowerCase().replace(/[\s-]+/g, '_');
  const branch = (lead.branch || '').toLowerCase();
  const offerStatus = lead.offerStatus || 'keins';

  let score = 12;
  const statusW = {
    neu: 8, erstkontakt: 12, versucht: 14, interessiert: 28,
    nachgefasst: 32, rückruf: 30, callback: 30, angebot: 48,
    terminiert: 52, termin: 52, nicht_interessiert: 4, verloren: 4, abgesagt: 4, kunde: 95,
  };
  score += statusW[status] ?? 18;

  const branchBonus = ['holz', 'metall', 'elektro', 'shk', 'zimmer'].some(k => branch.includes(k)) ? 6 : 0;
  score += branchBonus;

  const offerBonus = { keins: 0, versendet: 8, in_verhandlung: 18, angenommen: 28, abgelehnt: 0 };
  score += offerBonus[offerStatus] ?? 0;
  if (lead.offerAmount && Number(lead.offerAmount) > 0) score += 5;

  const lastMs = latestActivityTimestampMs(activities);
  if (lastMs != null) {
    const days = (Date.now() - lastMs) / 86400000;
    if (days < 2) score += 12;
    else if (days < 7) score += 8;
    else if (days < 14) score += 4;
    else if (days > 30) score -= 6;
  }

  const actN = Array.isArray(activities) ? activities.length : 0;
  if (actN >= 6) score += 10;
  else if (actN >= 3) score += 5;
  else if (actN >= 1) score += 2;

  return Math.max(2, Math.min(98, Math.round(score)));
}
